
import { apiRequest } from '@common/api/utils';

const QUESTIONS_BASE_URL = '/review/api/v1/qna/questions';
const TESTIMONIALS_ENDPOINT = '/success-stories/testimonials';
const GET_QUESTIONS_ENDPOINT = '/review/api/v1/qna/questions';
const SUBMIT_QUESTIONS_ENDPOINT = QUESTIONS_BASE_URL;
const VERIFY_QUESTIONS_ENDPOINT = `${QUESTIONS_BASE_URL}/verify-questions`;
const SUBMIT_USER_DETAILS_ENDPOINT = '/review/api/v1/qna/users';
const QUESTION_ENDPOINT = '/review/api/v1/qna/questions';
const INITIAL_RESOURCE_ENDPOINT = '/review/alum-init-load';

function fetchProfiles(queryParams, pageNumber, isNewQuickFilter = false) {
  return apiRequest(
    'POST',
    TESTIMONIALS_ENDPOINT,
    {
      page_number: pageNumber,
      per_page: 12,
      sort_by: 'eligible_for_qna',
      new_quick_filters: isNewQuickFilter,
      ...queryParams,
    },
  );
}

function submitQuestion(askedToId, description, recaptcha = null) {
  return apiRequest(
    'POST',
    SUBMIT_QUESTIONS_ENDPOINT,
    {
      asked_to_id: askedToId,
      description,
      'cf-turnstile-response': recaptcha,
    },
  );
}

function verifyQuestions(askedToId) {
  return apiRequest(
    'POST',
    VERIFY_QUESTIONS_ENDPOINT,
    {
      asked_to_id: askedToId,
    },
  );
}

function submitUserDetails(data) {
  return apiRequest(
    'POST',
    SUBMIT_USER_DETAILS_ENDPOINT,
    data,
  );
}

function getQuestions(askedToId) {
  return apiRequest(
    'GET',
    `${GET_QUESTIONS_ENDPOINT}/?asked_to_id=${askedToId}`,
  );
}

function initialLoad() {
  return apiRequest(
    'GET',
    INITIAL_RESOURCE_ENDPOINT,
  );
}

function updateQuestion(questionId, description, recaptcha = null) {
  return apiRequest(
    'PATCH',
    `${QUESTION_ENDPOINT}/${questionId}`,
    {
      description,
      'cf-turnstile-response': recaptcha,
    },
  );
}

function deleteQuestion(questionId, recaptcha = null) {
  return apiRequest(
    'DELETE',
    `${QUESTION_ENDPOINT}/${questionId}`,
    {
      'cf-turnstile-response': recaptcha,
    },
  );
}

export default {
  fetchProfiles,
  getQuestions,
  submitQuestion,
  verifyQuestions,
  submitUserDetails,
  updateQuestion,
  deleteQuestion,
  initialLoad,
};
